import { useApolloClient } from "@apollo/client";
import { Cancel } from "@mui/icons-material";
import { Button, Dialog } from "@mui/material";
import { ContentWrapper } from "@src/components";
// eslint-disable-next-line @comet/no-private-sibling-import
import { FormButtonsWrapper } from "@src/domain/devices/edit/Form.sc";
import { type GQLRestoreUserMutation, type GQLRestoreUserMutationVariables } from "@src/graphql.generated";
import Delete from "@src/icons/Delete";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

// eslint-disable-next-line @comet/no-private-sibling-import
import { restoreUser } from "./Table.gql";

export const RestoreUserDialog: FC<PropsWithChildren<{ id: string | null; handleClose: () => void }>> = ({ id, handleClose }) => {
    const client = useApolloClient();

    const handleClick = () => {
        if (id) {
            client.mutate<GQLRestoreUserMutation, GQLRestoreUserMutationVariables>({
                mutation: restoreUser,
                variables: {
                    id,
                },
                refetchQueries: ["UsersListAdmin"],
            });
        }

        handleClose();
    };

    return (
        <Dialog open={!!id} onClose={handleClose}>
            <ContentWrapper title={<FormattedMessage id="reviermanager.dialog.restore.user.title" defaultMessage="Kunde wiederherstellen" />}>
                <FormButtonsWrapper>
                    <Button startIcon={<Cancel />} variant="text" onClick={handleClose}>
                        <FormattedMessage id="reviermanager.button.cancel" defaultMessage="Abbrechen" />
                    </Button>
                    <Button color="primary" variant="contained" startIcon={<Delete />} onClick={handleClick}>
                        <FormattedMessage id="reviermanager.dialog.restore.user" defaultMessage="Ja, wiederherstellen" />
                    </Button>
                </FormButtonsWrapper>
            </ContentWrapper>
        </Dialog>
    );
};
